"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoginPropsWithIntl = void 0;
const thirdPartyLogin_1 = require("../constants/thirdPartyLogin");
const messages_1 = __importDefault(require("../messages"));
const getLoginPropsWithIntl = ({ thirdPartyLoginProps = {}, intl }) => {
    if (!intl)
        return null;
    const { type, login, logout } = thirdPartyLoginProps, rest = __rest(thirdPartyLoginProps, ["type", "login", "logout"]);
    if (type === thirdPartyLogin_1.EHR_MYCHART) {
        return Object.assign(Object.assign({}, rest), { type, login: Object.assign(Object.assign({}, login), { header: intl.formatMessage(messages_1.default.mychartLoginHeader), description: intl.formatMessage(messages_1.default.mychartLoginDescription), action: intl.formatMessage(messages_1.default.mychartLoginAction), separator: intl.formatMessage(messages_1.default.mychartLoginSeparator) }), logout: Object.assign(Object.assign({}, logout), { description: intl.formatMessage(messages_1.default.mychartLogoutDescription), action: intl.formatMessage(messages_1.default.mychartLogoutAction) }) });
    }
    return null;
};
exports.getLoginPropsWithIntl = getLoginPropsWithIntl;
//# sourceMappingURL=getLoginPropsWithIntl.js.map